/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { PaginationInfo } from './paginationInfo';

export type GenericApiResponseModuleUpgradePreviewResponsePagination = PaginationInfo | null;
